import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ApparelLogo } from "../components/brand/Logos";
import CmsText from "../components/CmsText";
import { useSiteText } from "../store/useSiteContent";

export default function ApparelComingSoon() {
  const headline = useSiteText("apparel.hero.headline", "*Coming soon.*");
  const body = useSiteText(
    "apparel.hero.body",
    "We're changing things up a bit. Heritage Apparel will be back. Until then, take a wander through Heritage Dahlias."
  );
  return (
    <main
      data-testid="apparel-coming-soon"
      className="min-h-[100svh] flex flex-col bg-[var(--heritage-bone)] text-[var(--heritage-ink)]"
    >
      <header className="px-5 md:px-10 py-5 md:py-6 flex items-center justify-between border-b border-[var(--heritage-ink)]/10">
        <Link
          to="/"
          data-testid="apparel-back-link"
          className="inline-flex items-center gap-2 font-label tracking-[0.3em] text-[var(--heritage-ink)]/70 hover:text-[var(--heritage-ink)] transition"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
        <span className="font-label tracking-[0.4em] text-[var(--heritage-ink)]/70">Aotearoa · NZ</span>
      </header>

      <section className="flex-1 flex flex-col justify-center items-center text-center px-6 md:px-12 lg:px-16 py-14 md:py-24 bg-[var(--heritage-bone)]">
        <ApparelLogo
          data-testid="apparel-logo"
          className="w-[min(70vw,360px)] h-auto"
        />

        <span
          data-testid="apparel-status-pill"
          className="mt-10 inline-block px-5 py-2 font-label tracking-[0.4em] text-xs md:text-sm bg-[var(--heritage-ink)] text-[var(--heritage-bone)] wobble-pill"
        >
          ✦ COMING SOON ✦
        </span>

        <h1
          data-testid="apparel-heading"
          className="font-display text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05] max-w-md whitespace-pre-line"
        >
          <CmsText text={headline} italicClass="font-display-italic text-[var(--heritage-burgundy)]" />
        </h1>

        <p className="mt-6 max-w-md text-base md:text-lg text-[var(--heritage-ink)]/75 leading-relaxed whitespace-pre-line">
          {body}
        </p>

        <Link
          to="/dahlias"
          data-testid="apparel-to-dahlias"
          className="mt-10 inline-flex items-center gap-3 px-8 py-4 bg-[var(--heritage-ink)] text-[var(--heritage-bone)] hover:bg-[var(--heritage-burgundy)] transition-colors font-label tracking-[0.3em] wobble-pill"
        >
          Visit Heritage Dahlias →
        </Link>
      </section>

      <footer className="px-5 md:px-10 py-5 text-center text-xs text-[var(--heritage-ink)]/55 border-t border-[var(--heritage-ink)]/10">
        © {new Date().getFullYear()} Heritage · Family grown since 1932
      </footer>
    </main>
  );
}
